import invariant from "tiny-invariant";
import { MaintainStreakInfo, StreakCheckInfo } from "@lifeat/shared/data-models/user/UserMetrics/UserMetrics";
import * as UserMetricsUtil from "@lifeat/shared/data-models/user/UserMetrics/UserMetricsUtil";
import * as DateUtil from "@lifeat/shared/util/DateUtil";
import { functions } from "@firebase-local/firebase";
import { USER_METRICS_FUNCTIONS } from "@firebase-local/functions/ServerlessEndpoints";
import { logError } from "@service/ConsoleLoggerService";

export const attemptUserDailyStreakUpdate = (uid: string, lastLoginDateTimestampIsoStr: string) => {
    const isoTimeStamp = DateUtil.getCurrDateIsoTimeStamp();
    const streakCheckInfo: StreakCheckInfo = UserMetricsUtil.canUserIncreaseStreak(
        isoTimeStamp,
        lastLoginDateTimestampIsoStr,
    );

    if (streakCheckInfo.shouldUpdateData) {
        invariant(uid, "Error attempting streak update: uid is undefined");
        invariant(isoTimeStamp, "Error attempting streak update: isoTimeStamp is undefined");
        invariant(
            streakCheckInfo.canMaintainStreak != null,
            "Error attempting streak update: canMaintainStreak is undefined",
        );

        const updateData: MaintainStreakInfo = {
            uid: uid,
            maintainStreak: streakCheckInfo.canMaintainStreak,
            newLoginTimestampISOString: isoTimeStamp,
        };

        functions
            .httpsCallable(USER_METRICS_FUNCTIONS.UpdateUserStreak)(updateData)
            .catch((error) => {
                logError(
                    `There was an error [code: ${error.code}, message: ${error.message}] ` + `updating user streak.`,
                );
            });
    }
};
